export * from './lib/multiple-search-input.module';
